import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchJSON } from '../../../../../../../../../../utils/hooks/useFetchJson'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalRecalculateSellInvoiceProps extends ModalEditComponentProps {}

const ModalRecalculateSellInvoice: React.FC<ModalRecalculateSellInvoiceProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchJSON } = useFetchJSON({
        onSubmit,
        url: '/api/app/order/sell/sellInvoice/recalculatePricesSellInvoice',
        data: allRowData?.header || {}
    })
    const { handleFetchJSONLoading, loading } = useModalRecalculateSellInvoiceLogic({ handleFetchJSON })
    return (
        <ModalSmallFilled opened={true} loading={loading} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchJSONLoading} translations={{
            title: t('sureRecalculateSellInvoice', '¿Seguro que quieres recalcular esta factura de venta?'),
            subtitle: t('recalculateProductPrices', 'Recalculará los precios de los productos'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}

interface ModalRecalculateSellInvoiceLogicProps {
    handleFetchJSON: () => Promise<void>
}

const useModalRecalculateSellInvoiceLogic = ({ handleFetchJSON }: ModalRecalculateSellInvoiceLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const handleFetchJSONLoading = useCallback(async () => {
        startLoading()
        await handleFetchJSON()
        endLoading()
    }, [startLoading, handleFetchJSON, endLoading])
    return { handleFetchJSONLoading, loading }
}

export default ModalRecalculateSellInvoice